module.exports = __webpack_public_path__ + "static/img/lottery_banner.cbf2ed9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lottery_banner.png
// module id = 3zUd
// module chunks = 6